import React, { useEffect } from "react";
import CarList from "../components/CarList/CarList"; // Assure-toi que tu importes CarList

const CarListPage = () => {
  useEffect(() => {
    // Définir le titre de la page de liste des voitures
    document.title = "AMSEBRID - Location de voitures à Bejaia";
  }, []);

  return (
    <div>
      <CarList />
    </div>
  );
};

export default CarListPage;
